var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "md:ml-8 flex-1" }, [
    _c(
      "div",
      { staticClass: "p-2 sm:p-6 bg-white rounded-lg" },
      [
        _c("SectionHeader", {
          attrs: { title: "Goals", currentUser: _vm.currentUser },
          on: {
            edit: function ($event) {
              return _vm.$emit("edit")
            },
          },
        }),
        _c("hr", { staticClass: "border-t border-gray-100 mb-4" }),
        _c(
          "InfoSection",
          [
            _c("InfoField", { attrs: { label: "Dietary / Nutrition Goals" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Type: " + _vm._s(_vm.data.nutrition_goals_type || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Description: " +
                    _vm._s(_vm.data.nutrition_goals_description || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Related Diagnosis: " +
                    _vm._s(_vm.data.nutrition_goals_diagnosis || "N/A") +
                    " "
                ),
              ]),
            ]),
            _c("InfoField", { attrs: { label: "Medication Goals" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Timing Requirements: " +
                    _vm._s(_vm.data.medication_goals_timing || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Supervision Needed: " +
                    _vm._s(
                      _vm.data.medication_goals_supervision ? "Yes" : "No"
                    ) +
                    " "
                ),
              ]),
            ]),
            _c("InfoField", { attrs: { label: "Personal Care Goals" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Hygiene Goals: " +
                    _vm._s(_vm.data.personal_goals_hygiene || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Self-Care Support: " +
                    _vm._s(_vm.data.personal_goals_self_care || "N/A") +
                    " "
                ),
              ]),
            ]),
            _c("InfoField", { attrs: { label: "Skin Integrity Goals" } }, [
              _c("p", { staticClass: "text-gray-600" }, [
                _vm._v(
                  " Wound Monitoring: " +
                    _vm._s(_vm.data.skin_goals_wound || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " Change Reporting: " +
                    _vm._s(_vm.data.skin_goals_reporting || "N/A")
                ),
                _c("br"),
                _vm._v(
                  " General Notes: " +
                    _vm._s(_vm.data.skin_goals_notes || "N/A") +
                    " "
                ),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }